// These actions are sorted by order of priority, index 0 being the most important
import { ActionType } from '../design-system/types';

export const ActionTypes: ActionType[] = [
    'discover',
    'make_a_quote',
    'call',
    'ask_for_payment',
    'follow_up',
    'archive',
    'other',
];
